module.exports = __webpack_public_path__ + "img/scotlandMap.53390568.png";